const questions = [
  {  question: "Name of the bird in sanskrit is",
    imgSrc: "https://www.allaboutbirds.org/guide/assets/photo/59858041-480px.jpg",
    choice1: 'काकः',
    choice2: 'गरुडः',
    choice3: 'शशः',
    choice4: 'दराहः', 
    answer: 1,
},
{
    question: "Name of the bird in Sanskrit is",
    imgSrc: "https://i.pinimg.com/originals/fe/d3/fe/fed3fe3a113659f28c4de5c7d205fcc3.jpg",
    choice1: 'हंसः',
    choice2: 'मरालः',
    choice3: 'उलूकः',
    choice4: 'दराहः', 
    answer: 3,
},
{
    question: "Name of the bird in Sanskrit is",
    imgSrc: "https://www.allaboutbirds.org/guide/assets/photo/66031271-480px.jpg",
    choice1: 'कोपातः',
    choice2: 'मरालः',
    choice3: 'सरिकाः',
    choice4: 'वर्तकः', 
    answer: 1,
},
{
    question: "Name of the bird in Sanskrit is",
    imgSrc: "https://i.pinimg.com/originals/32/46/8c/32468cd612605d07175f57e065292d5a.jpg",
    choice1: 'कोपातः',
    choice2: 'जतुका',
    choice3: 'गृधः',
    choice4: 'श्येनः', 
    answer: 4,
},
{
    question: "Name of the bird in Sanskrit is",
    imgSrc: "https://www.thespruce.com/thmb/OYDoW8_72D6WP-MvTQ2x676gJ5Y=/1500x844/smart/filters:no_upscale()/mute-swan-adult-58ad87433df78c345b85b294.jpg",
    choice1: 'मरालः',
    choice2: 'शुकः',
    choice3: 'गृकुक्कुटः',
    choice4: 'श्येनः', 
    answer: 1,
},
{
    question: "Name of the bird in Sanskrit is",
    imgSrc: "https://i.cdn.newsbytesapp.com/images/l158_14871576661020.jpg",
    choice1: 'शशः',
    choice2: 'शुकः',
    choice3: 'काकः',
    choice4: 'श्येनः', 
    answer: 2,
},
{
    question: "Name of the animal in Sanskrit is",
    imgSrc: "https://images.unsplash.com/photo-1561731216-c3a4d99437d5?ixlib=rb-1.2.1",
    choice1: 'श्रृगालः',
    choice2: 'सिंहः',
    choice3: 'व्याघ्रः',
    choice4: 'श्येनः', 
    answer: 3,
},
{
    question: "Name of the animal in Sanskrit is",
    imgSrc: "https://images.immediate.co.uk/production/volatile/sites/23/2018/09/jackal_shimi_eni_iStock_623-778f4bd.jpg?quality=90&resize=768,574",
    choice1: 'श्रृगालः',
    choice2: 'भल्लूकः',
    choice3: 'व्याघ्रः',
    choice4: 'रुडः', 
    answer: 1,
},
{
    question: "Name of the animal in Sanskrit is",
    imgSrc: "https://i.guim.co.uk/img/media/8f02bb49224d9a94699b75213664bf898617c062/0_288_5315_3189/master/5315.jpg?width=1200&height=1200&quality=85&auto=format&fit=crop&s=89721e1224115e05a05203a62cf93f7c",
    choice1: 'भल्लूकः',
    choice2: 'वृकः',
    choice3: 'व्याघ्रः',
    choice4: 'हरिणः', 
    answer: 2,
},
{
    question: "Name of the animal in Sanskrit is",
    imgSrc: "https://img.etimg.com/thumb/msid-50560952,width-300,imgsize-84507,,resizemode-4,quality-100/.jpg",
    choice1: 'हरिणः',
    choice2: 'भल्लूकः',
    choice3: 'गृकुक्कुटः',
    choice4: 'वानरः', 
    answer: 4,
},
{
    question: "Name of the animal in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/0/0c/Cow_female_black_white.jpg",
    choice1: 'धेनुः',
    choice2: 'महिषः',
    choice3: 'अश्वः',
    choice4: 'वृषभः', 
    answer: 1,
},
{
    question: "Name of the animal in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/6/66/An_up-close_picture_of_a_curious_male_domestic_shorthair_tabby_cat.jpg",
    choice1: 'गर्दभः',
    choice2: 'बिडालः',
    choice3: 'अजः',
    choice4: 'मेषः', 
    answer: 2,
},
{
    question: "Name of the animal in Sanskrit is",
    imgSrc: "https://i.ytimg.com/vi/muCshzf8k2Q/maxresdefault.jpg",
    choice1: 'चित्रकः',
    choice2: 'गृकुक्कुटः',
    choice3: 'कुक्कुरः',
    choice4: 'कृकलासः', 
    answer: 3,
},
{
    question: "Name of the animal in Sanskrit is",
    imgSrc: "https://c402277.ssl.cf1.rackcdn.com/photos/18330/images/hero_small/Mountain_Gorilla_Silverback_WW22557.jpg?1576515753",
    choice1: 'वृषभः',
    choice2: 'अश्वः',
    choice3: 'वानरः',
    choice4: 'वनमनुष्यः', 
    answer: 4,
},
{
    question: "Name of the animal in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/b/b2/Hausziege_04.jpg",
    choice1: 'गर्दभः',
    choice2: 'अजः',
    choice3: 'वृषभः',
    choice4: 'भल्लूकः', 
    answer: 2,
},
{
    question: "Name of the Fruit in Sanskrit is",
    imgSrc: "https://cdn.mos.cms.futurecdn.net/42E9as7NaTaAi4A6JcuFwG-1200-80.jpg",
    choice1: 'अनासम्',
    choice2: 'कालिङ्गम्',
    choice3: 'कदलिका',
    choice4: 'आम्रम्', 
    answer: 3,
},
{
    question: "Name of the Fruit in Sanskrit is",
    imgSrc: "https://www.theproducemoms.com/wp-content/uploads/2016/02/Ripe-pomegranate-fruit-1.jpg",
    choice1: 'दाडिमः',
    choice2: 'पनसम्',
    choice3: 'द्राक्षाफलम्',
    choice4: 'नारङ्गम्', 
    answer: 1,
},
{
    question: "Name of the Fruit in Sanskrit is",
    imgSrc: "https://images-na.ssl-images-amazon.com/images/I/61IO4txt5ZL._SL1200_.jpg",
    choice1: 'पनसम्',
    choice2: 'द्राक्षाफलम्',
    choice3: 'कालिङ्गम्',
    choice4: 'जम्‍बीरम्', 
    answer: 2,
},
{
    question: "Name of the Fruit in Sanskrit is",
    imgSrc: "https://www.finedininglovers.com/sites/g/files/xknfdk626/files/styles/im_landscape_100/public/2020-02/Wood-Apple.jpg?itok=6FsxfUIM",
    choice1: 'प्रबदरम्',
    choice2: 'जम्बु',
    choice3: 'आग्रलम्',
    choice4: 'कपित्थम्', 
    answer: 4,
},
{
    question: "Name of the Fruit in Sanskrit is",
    imgSrc: "https://images.unsplash.com/photo-1560155069-ad79768f2666?ixid=MXwxMjA3fDB8MHxzZWFyY2h8M3x8c3RyYXdiZXJyeXxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80",
    choice1: 'आग्रलम्',
    choice2: 'तृण-बदरम्',
    choice3: 'खर्बुजम्',
    choice4: 'उदुम्बरम्', 
    answer: 2,
},
{
    question: "Name of the Fruit in Sanskrit is",
    imgSrc: "https://images-na.ssl-images-amazon.com/images/I/414STUUsfvL._SX466_.jpg",
    choice1: 'जम्बु',
    choice2: 'अमृतफलम्',
    choice3: 'अनासम्',
    choice4: 'प्रबदरम्', 
    answer: 1,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Nymphaea_stellata%2C_Myanmar.jpg/240px-Nymphaea_stellata%2C_Myanmar.jpg",
    choice1: 'जपपुशम',
    choice2: 'कृष्ण कमलम',
    choice3: 'स्‍थलपद्मम्',
    choice4: 'रजनीगन्‍धा', 
    answer: 2,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://www.1mg.com/hi/patanjali/wp-content/uploads/2018/10/Nagkesar-1.png",
    choice1: 'धतूर',
    choice2: 'शेफालिका',
    choice3: 'किंशुक',
    choice4: 'नागपुष्प', 
    answer: 4,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://t3.ftcdn.net/jpg/02/94/99/94/360_F_294999466_f3Zulh1kL3fI9Cc2Fo5Z37ZP3zn87Yfd.jpg",
    choice1: 'मल्लिका',
    choice2: 'व्याधिघात',
    choice3: 'म्लानम्',
    choice4: 'प्रफुल्लम्', 
    answer: 3,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://5.imimg.com/data5/IU/BJ/MY-2662260/white-lotus-absolute-oil-500x500.jpg",
    choice1: 'इन्‍दीवरम्',
    choice2: 'कैरवम्',
    choice3: 'पद्मम्',
    choice4: 'कोकनदम्', 
    answer: 2,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://images.unsplash.com/photo-1561238160-3fd50893667f?ixid=MXwxMjA3fDB8MHxzZWFyY2h8M3x8cmVkJTIwcm9zZXxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80",
    choice1: 'पाटलम्',
    choice2: 'जातीपुष्पम्',
    choice3: 'पुष्प:',
    choice4: 'यूथिका', 
    answer: 1,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://5.imimg.com/data5/PT/FW/MY-42914277/champa-flower-plant-500x500.jpg",
    choice1: 'कर्णोरः',
    choice2: 'उत्पलम्',
    choice3: 'चम्पकम्',
    choice4: 'दिवाकरः', 
    answer: 3,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://cdn.meaninginhindi.net/wp-content/uploads/2020/07/Pandanus-flower.jpg",
    choice1: 'जाम्भजम्',
    choice2: 'उत्पलम्',
    choice3: 'पद्मिनी',
    choice4: 'कैतकम्', 
    answer: 4,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://cdn.meaninginhindi.net/wp-content/uploads/2020/07/Rosemallows-flower.jpg",
    choice1: 'जपपुशम',
    choice2: 'यूथिका',
    choice3: 'आभरण',
    choice4: 'शेफालिका', 
    answer: 1,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://cdn.meaninginhindi.net/wp-content/uploads/2020/07/bela-flower.jpg",
    choice1: 'विकचम्',
    choice2: 'मल्लिका',
    choice3: 'विकसितम्',
    choice4: 'सफुटम्', 
    answer: 2,
},
{
    question: "Name of Flower in Sanskrit is",
    imgSrc: "https://cdn.meaninginhindi.net/wp-content/uploads/2020/07/blossom.jpg",
    choice1: 'जाम्भजम्',
    choice2: 'पद्मिनी',
    choice3: 'कैतकम्',
    choice4: 'पाटलम्', 
    answer: 1,
},
{
    question: "Name of Bodypart in Sanskrit is",
    imgSrc: "https://www.factsjustforkids.com/images/the-human-nose.png",
    choice1: 'स्कन्धः ',
    choice2: 'नाभिः',
    choice3: 'नासिका',
    choice4: 'नखः', 
    answer: 3,
},
{
    question: "Name of Bodypart in Sanskrit is",
    imgSrc: "https://visioneyeinstitute.com.au/wp-content/uploads/laser-eye-safety.jpg",
    choice1: 'अङ्गुली',
    choice2: 'नेत्रम्',
    choice3: 'केशः',
    choice4: 'पादः', 
    answer: 2,
},   
{
    question: "Name of Bodypart in Sanskrit is",
    imgSrc: "https://stonehavendental.com/wp-content/uploads/2018/05/The_Different_Types_of_Teeth.jpg",
    choice1: 'कर्णः',
    choice2: 'उदरम्',
    choice3: 'दन्तः',
    choice4: 'मुखम्', 
    answer: 3,
},   
{
    question: "Name of Bodypart in Sanskrit is",
    imgSrc: "https://post.healthline.com/wp-content/uploads/2020/09/732x549_How_to_Identify_and_Treat_Nail_Pitting-1-732x549.jpg",
    choice1: 'वदनः',
    choice2: 'नखः',
    choice3: 'उदरम्',
    choice4: 'दन्तः', 
    answer: 2,
},
{
    question: "Name of Bodypart in Sanskrit is",
    imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmEBKrutsTRVGEnRpW2pzRYMs57fT4iEo8hQ&usqp=CAU",
    choice1: 'उरः',
    choice2: 'कनिष्ठिका',
    choice3: 'पलितम्',
    choice4: 'अस्थि', 
    answer: 1,
},
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Downward-Facing-Dog.JPG/560px-Downward-Facing-Dog.JPG",
    choice1: 'आकर्णधनुरासन',
    choice2: 'अधोमुखवृक्षासन',
    choice3: 'अधोमुखश्वानासन',
    choice4: '	अनन्तासन', 
    answer: 3,
},    
{
    question: "Name of Bodypart in Sanskrit is",
    imgSrc: "https://st.depositphotos.com/1102480/1347/i/600/depositphotos_13473158-stock-photo-woman-hand.jpg",
    choice1: 'ललाटम्',
    choice2: 'श्मश्रुः',
    choice3: 'उरः',
    choice4: 'करः', 
    answer: 4,
},    
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Bhujapidasana_Yoga-Asana_Nina-Mel.jpg/440px-Bhujapidasana_Yoga-Asana_Nina-Mel.jpg",
    choice1: 'भुजपीडासन',
    choice2: 'बिडालासन',
    choice3: 'मार्जरीआसन',
    choice4: 'गोमुखासन', 
    answer: 1,
},    
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Gomukhasana_Yoga-Asana_Nina-Mel.jpg/440px-Gomukhasana_Yoga-Asana_Nina-Mel.jpg",
    choice1: 'गोरक्षासन',
    choice2: 'गोमुखासन',
    choice3: 'गरुडासन',
    choice4: 'हलासन', 
    answer: 2,
},  
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Kraunchasana_%28Leon_black_background.jpg/440px-Kraunchasana_%28Leon_black_background.jpg",
    choice1: 'क्रौञ्चासन',
    choice2: 'कौण्डिन्यसन',
    choice3: 'कर्णपीडासन',
    choice4: 'कपोतासन', 
    answer: 1,
}, 
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Peacock_pose.jpg/440px-Peacock_pose.jpg",
    choice1: 'मयूरासन',
    choice2: 'मत्स्येन्द्रासन',
    choice3: 'मुक्तासन',
    choice4: 'मत्स्यासन', 
    answer: 1,
},
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Mr-yoga-lord_of_dance_-_both_arms.jpg/440px-Mr-yoga-lord_of_dance_-_both_arms.jpg",
    choice1: 'नावासन',
    choice2: 'नटराजासन',
    choice3: 'परिपूर्णनावासन',
    choice4: 'नौकासन', 
    answer: 2,
},  
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Utthita-Parshvakonasana_Yoga-Asana_Nina-Mel.jpg/600px-Utthita-Parshvakonasana_Yoga-Asana_Nina-Mel.jpg",
    choice1: 'पद्मासन',
    choice2: 'परिघासन',
    choice3: 'पार्श्वकोणासन',
    choice4: 'पार्श्वोत्तनासन', 
    answer: 3,
},   
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Practice_%281%29_%2816383984312%29.jpg/600px-Practice_%281%29_%2816383984312%29.jpg",
    choice1: 'पाशासन',
    choice2: 'पिञ्चमयूरासन',
    choice3: 'पश्चिमोत्तानासन',
    choice4: 'प्रसारित पादोत्तानासन', 
    answer: 4,
},
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/b/b1/Raja_sarvangasana.jpg",
    choice1: 'राजकपोतासन',
    choice2: 'शलभासन',
    choice3: 'सालम्बसर्वाङ्गासन',
    choice4: 'समकोणासन', 
    answer: 3,
},  
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Shirshasana.jpg/174px-Shirshasana.jpg",
    choice1: 'सिद्धासन',
    choice2: 'शवासन',
    choice3: 'सिंहासन',
    choice4: 'शीर्षासन', 
    answer: 4,
},
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/Mr-yoga-firefly-pose-1.jpg/440px-Mr-yoga-firefly-pose-1.jpg",
    choice1: 'सुर्य नमस्कार',
    choice2: 'स्वस्तिकसन',
    choice3: 'ताडासन',
    choice4: 'टिट्टिभासन', 
    answer: 4,
},
{
    question: "Name of Yoga asana in Sanskrit is",
    imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Yoga-tulasana.JPG/440px-Yoga-tulasana.JPG",
    choice1: 'त्रिविक्रमासन',
    choice2: 'तुलासन',
    choice3: 'उपविष्टकोणासन',
    choice4: 'ऊर्ध्वमुखश्वानासन', 
    answer: 2,
},
{
    question: "Name of Gadget in Sanskrit is",
    imgSrc: "https://glosbe.com/fb_img/meaningImageMedium/Nh419025_wikimedia_8435220492467696389_Early_portable_tv.jpg",
    choice1: 'वदनः',
    choice2: 'दूरदर्शनम्',
    choice3: 'करः',
    choice4: 'गरुडः', 
    answer: 2,
}
]

export default questions